import { jsx } from "panel";
import { selx } from "clsx";
import { canUseViewN } from "common/components/data-table/utils";
import { SvgIconEl } from "common/components/svg-icon";
import { FlowsSankeyChartWidgetEl } from "common/report/flows/charts/flows-sankey-chart";
import { FlowsTopPathsChartWidgetEl } from "common/report/flows/charts/flows-top-paths-chart";
import { FunnelsStepChartEl } from "common/report/insights/charts/funnels-step-chart/panel";
import { InsightsBarChartEl } from "common/report/insights/charts/insights-bar-chart/panel";
import { InsightsMetricChartEl } from "common/report/insights/charts/insights-metric-chart/panel";
import { InsightsLineChartEl } from "common/report/insights/charts/insights-line-chart/panel";
import { InsightsPieChartEl } from "common/report/insights/charts/insights-pie-chart";
import { InsightsTableChartEl } from "common/report/insights/charts/insights-table-chart/panel";
import { RetentionCurveChartEl } from "common/report/insights/charts/retention-curve-chart/panel";
import { ChartRootEl } from "common/charts/root";
import styles from "./index.module.styl";
const CardHeader = (props) => {
  const cmp = props.cmp;
  return /* @__PURE__ */ jsx("div", { key: "card-header", sel: selx(styles.cardHeader), "data-sentry-component": "CardHeader", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", { sel: selx([styles.cardTitle, ".bold"]), attrs: {
    title: cmp.params.cardTitle
  } }, /* @__PURE__ */ jsx("div", { sel: selx(styles.nameContainer) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.sideIcon) }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "brand-insights"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("p", null, cmp.params.cardTitle)))));
};
const CardChart = (props) => {
  const cmp = props.cmp;
  const {
    chartParams
  } = cmp.params;
  const chartType = cmp.params.chartOptions.type;
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.cardChart), style: {
    overflow: chartType === cmp.ChartType.Line || chartType === cmp.ChartType.StackedLine ? "hidden" : "auto"
  }, "data-sentry-component": "CardChart", "data-sentry-source-file": "template.tsx" }, !cmp.params.reportLoading ? chartType === cmp.ChartType.Metric ? /* @__PURE__ */ jsx("div", { sel: ".common-metric-container" }, /* @__PURE__ */ jsx(InsightsMetricChartEl, { paramsAndResults: {
    params: cmp.getBookmarkParamsWithDashboardOverrides(),
    results: chartParams
  }, dataGroups: cmp.getDataGroups() })) : chartType === cmp.ChartType.FunnelSteps ? /* @__PURE__ */ jsx(FunnelsStepChartEl, { sel: selx(styles.fullHeight), ...{
    bookmarkData: cmp.getFunnelStepsBookmarkData(),
    loaded: true,
    projectDetails: {
      projectId: cmp.params.projectId.toString(),
      projectAsOfDate: cmp.params.projectAsOfDate,
      projectTimeZone: cmp.params.projectTimezone,
      utcOffset: cmp.params.utcOffset
    }
  } }) : chartType === cmp.ChartType.Sankey ? /* @__PURE__ */ jsx(FlowsSankeyChartWidgetEl, { attrs: cmp.getFlowSankeyChartAttributes(), props: cmp.getFlowsChartWidgetProps() }) : chartType === cmp.ChartType.FlowsTopPaths ? /* @__PURE__ */ jsx(FlowsTopPathsChartWidgetEl, { attrs: {
    loaded: true
  }, props: cmp.getFlowsChartWidgetProps() }) : chartType === cmp.ChartType.Line || chartType === cmp.ChartType.StackedLine ? /* @__PURE__ */ jsx(InsightsLineChartEl, { sel: ".line-chart", loaded: true, timezone: cmp.params.projectTimezone, utcOffset: cmp.params.utcOffset, dataGroups: cmp.getDataGroups(), paramsAndResults: {
    params: cmp.getBookmarkParamsWithDashboardOverrides(),
    results: chartParams
  } }) : chartType === cmp.ChartType.StackedBar || chartType === cmp.ChartType.Bar ? /* @__PURE__ */ jsx(InsightsBarChartEl, { dataGroups: cmp.getDataGroups(), paramsAndResults: {
    params: cmp.getBookmarkParamsWithDashboardOverrides(),
    results: chartParams
  } }) : chartType === cmp.ChartType.Pie ? /* @__PURE__ */ jsx(InsightsPieChartEl, { sel: ".pie-chart", attrs: {
    loaded: true
  }, props: {
    paramsAndResults: {
      params: cmp.getBookmarkParamsWithDashboardOverrides(),
      results: chartParams
    },
    dataGroups: cmp.getDataGroups()
  } }) : chartType === cmp.ChartType.Table ? /* @__PURE__ */ jsx(InsightsTableChartEl, { bookmarkParams: cmp.getBookmarkParamsWithDashboardOverrides(), results: chartParams, dataGroups: cmp.getDataGroups(), startScrolledRight: true, canUseViewN: canUseViewN() }) : chartType === cmp.ChartType.RetentionLine || cmp.ChartType.RetentionCurve ? /* @__PURE__ */ jsx(RetentionCurveChartEl, { ...cmp.getParamsForRetentionCurveChart() }) : null : null);
};
const ReportCard = (props) => {
  const cmp = props.cmp;
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.cardRoot), "data-sentry-component": "ReportCard", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(CardHeader, { cmp, "data-sentry-element": "CardHeader", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: selx(styles.cardReport) }, /* @__PURE__ */ jsx(ChartRootEl, { "data-sentry-element": "ChartRootEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(CardChart, { cmp, "data-sentry-element": "CardChart", "data-sentry-source-file": "template.tsx" }))));
};
export function template() {
  return /* @__PURE__ */ jsx(ReportCard, { cmp: this, "data-sentry-element": "ReportCard", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" });
}
